import {
    useEffect,
    useState
} from 'react';
import { FaEye, FaEyeSlash, FaUserAlt } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import neuron from '../../assets/SVGs/neuron.svg';
import background from '../../assets/SVGs/neuron_icon.svg';
import mi4u from '../../assets/image/logo-Mi4U.png';
import {
    Input,
    RadioButton,
    SelectCompanies
} from '../../components';
import { useAuth } from '../../contexts/auth';
import { getCompanyConfigByUrl } from '../../service/serviceChat/companyService';
import * as S from './styled';


export function Login() {

    const history = useHistory();
    const { version: appVersion } = require('../../../package.json');
    const { authCompany, onSetStatusUserSystem } = useAuth();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [configLogin, setConfigLogin] = useState(null);
    const [selectCompany, setSelectCompany] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [user, setUser] = useState({});
    const [statusUser, setStatusUser] = useState('ONLINE');
    const [hidePassword, setHidePassword] = useState(true);

    function reset() {
        localStorage.clear()
        sessionStorage.clear();
        setLoading(false);
        setUsername('');
        setPassword('');
    };

    useEffect(() => {
        if (window.location.search !== `?token_expired`) return
        toast.warn(
            'Sua sessão expirou. Faça login novamente !',
            { position: "top-center", theme: "colored" }
        );
        return
    }, [])
    useEffect(() => {
        reset();
        async function searchConfig() {
            const companyConfigLogin = await getCompanyConfigByUrl(
                window.location.href.replace("?token_expired#/", '')
            );
            setConfigLogin(companyConfigLogin);
        }
        searchConfig();
    }, []);

    async function handleSubmit(e) {
        if (!username && !password) {
            toast.warn(
                'Preencha usuário e senha para continuar',
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
            return
        };
        if (!username) {
            toast.warn(
                'Preencha usuário para continuar',
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
            return
        };
        if (!password) {
            toast.warn(
                'Preencha senha para continuar',
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
            return
        };
        setLoading(true);
        onSetStatusUserSystem(statusUser);
        const response = await authCompany(username, password, statusUser)
        if (!response?.error) {
            if (response?.isFirstAccess) {
                history.push('/first-access');
            } else {
                const { companies, user } = response
                setCompanies(companies)
                setUser(user)
                setSelectCompany(true)
            }
        } else {
            toast.error(
                `${response?.message}`,
                {
                    position: "top-center",
                    theme: "colored",
                }
            );
            reset()
            return
        };
    };

    function onKeyUp(e) {
        if (e.keyCode === 13) {
            handleSubmit();
        };
    };

    const HidePassword = () => {
        return (
            <span
                className='iHp'
                onClick={() => setHidePassword(!hidePassword)}
            >
                {(hidePassword)
                    ? (<FaEyeSlash fontSize={20} />)
                    : (<FaEye fontSize={20} />)
                }
            </span>
        )
    };


    return (
        <>
            {!selectCompany
                ? (
                    <S.Container>
                        <S.Content>
                            <S.Aside>
                                <S.Description $isVisible={Boolean(configLogin?.frase_01 || configLogin?.frase_02)}>
                                    {(configLogin?.frase_01) && <>{configLogin.frase_01}</>}
                                    <br />
                                    <span>
                                        {(configLogin?.frase_02) && <>{configLogin.frase_02}</>}
                                    </span>
                                </S.Description>
                                <S.ImageWrapper>
                                    <img
                                        src={background}
                                        alt='neuron'
                                        className='neuron'
                                    />
                                </S.ImageWrapper>
                            </S.Aside>
                            <S.Main>
                                <div className='form--container'>
                                    <S.Form.Wrapper>
                                        <S.Form.Header>
                                            <img
                                                src={mi4u}
                                                alt='mi4u'
                                                className='lo-mi4u'
                                            />
                                            <span className='separator' />
                                            <div className='title'>
                                                {`Faça aqui o seu`} <span>{`login`}</span>
                                            </div>
                                        </S.Form.Header>
                                        <S.Form.Content>
                                            <div className='input--container'>
                                                <Input
                                                    className='input--login'
                                                    autoComplete='off'
                                                    label='Digite seu login'
                                                    icon={<FaUserAlt fontSize={15} />}
                                                    value={username}
                                                    onChange={(e) => setUsername(e.target.value)}
                                                    disable={loading}
                                                    onKeyUp={onKeyUp}
                                                />
                                                <Input
                                                    className='input--login'
                                                    autoComplete='off'
                                                    type={hidePassword ? 'password' : 'text'}
                                                    label='Digite sua senha'
                                                    icon={<HidePassword />}
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    disable={loading}
                                                    onKeyUp={onKeyUp}
                                                />
                                            </div>
                                            <div className='status--user'>
                                                <RadioButton
                                                    id="status-user"
                                                    label='Online'
                                                    value='ONLINE'
                                                    onChange={(e) => setStatusUser(e)}
                                                    className='radio-btn'
                                                    checked={(statusUser) === 'ONLINE'}
                                                />
                                                <RadioButton
                                                    id="status-user"
                                                    label='Offline'
                                                    value='OFFLINE'
                                                    className='radio-btn'
                                                    onChange={(e) => setStatusUser(e)}
                                                    checked={(statusUser) === 'OFFLINE'}
                                                />
                                            </div>
                                            <div className='wrapper-btn'>
                                                <S.Button
                                                    $isLoading={loading}
                                                    onClick={() => handleSubmit()}
                                                >
                                                    {loading ? <S.Spinner /> : 'Entrar'}
                                                </S.Button>
                                            </div>
                                        </S.Form.Content>
                                    </S.Form.Wrapper>
                                </div>
                                <S.Footer>
                                    <div className='powered'>
                                        <span>Powered by</span>
                                        <img src={neuron} alt="neuron--" />
                                    </div>
                                    <div className='version'>
                                        <small>
                                            <i>{`v${appVersion}`}</i>
                                        </small>
                                    </div>
                                </S.Footer>
                            </S.Main>
                        </S.Content>
                    </S.Container >
                )
                : (
                    <SelectCompanies
                        companies={companies}
                        user={user}
                        username={username}
                        password={password}
                        statusUser={statusUser}
                    />
                )
            }
        </>
    );
}